import { AppRoutes } from '@shared/utils/navigation';

export const Page = {
  Url: {
    Dashboard: `/${AppRoutes.Dashboard}`,
    Customers: `/${AppRoutes.Customers}`,
    Users: `/${AppRoutes.Users}`,
    EvidenceLabeling: `/${AppRoutes.Files}/processing`,
    AllFiles: `/${AppRoutes.Files}`,
    VideoBrowser: `/${AppRoutes.Videos}`,
    PendingRemoval: `/${AppRoutes.Files}/deletion`,
    UploadFiles: `/${AppRoutes.Files}/upload`,
    SelfRedaction: '/self-redaction',
    Folders: `/${AppRoutes.Folders}`,
    SharedWithMe: `/${AppRoutes.Files}?pageType=1`,
    SharedByMe: `/${AppRoutes.Shared}`,
    Uploader: `/${AppRoutes.Downloads}`,
    Error: '/Error',
    Locked: '/locked',
    Login: '/login',
    Register: '/register',
    B2CLocked: '/user-not-found',
    B2CForbiden: '/forbidden',
  },
  Title: {
    Dashboard: 'Dashboard',
    Customers: 'app-title-manage-general-settings',
    Users: 'app-title-manage-users',
    EvidenceLabeling: 'Evidence labeling',
    AllFiles: 'app-title-files-list',
    VideoBrowser: 'Video browser',
    PendingRemoval: 'app-title-pending-removal',
    UploadFiles: 'app-title-files-upload',
    Folders: 'app-title-folders',
    SharedWithMe: 'app-title-shared-with-me',
    SharedByMe: 'app-title-shared-by-me',
    Uploader: 'app-tab-title-uploader',
    FileDetails: 'app-title-file-details',
    FolderDetails: 'app-title-folder-details',
    UserDashboard: 'User dashboard',
    SelfRedaction: 'ai-redaction-tool',
    Error404: '404',
    Error403: '403',
    Error500: 'Internal server error',
    Locked: 'Locked',
    Login: 'Login',
    Register: 'Register',
    Forbidden: 'Access forbidden',
  },
};
